import { DialogProps } from '../../components/Dialogs';
import * as actions from '../types';

export const dialogOpen = (payload: DialogProps) => ({
    type: actions.DIALOG_DISPLAY,
    payload
});

export const dialogClose = (id: string) => ({
    type: actions.DIALOG_CLOSE,
    id
});

export const dialogAlert = (message: string | DialogProps) => dispatch => dispatch(dialogOpen({
    ...(typeof message === 'string' ? { message } : message),
    buttons: [
        {
            label: 'Continuar',
            primary: true,
            onClick: (dialog) => {
                dialog.id && dispatch(dialogClose(dialog.id));
            }
        }
    ]
}));

export const dialogAlertEasyClose = (message: string) => dispatch => dispatch(dialogOpen({
    message,
    buttons: [
        {
            label: 'Continuar',
            primary: true,
            onClick: (dialog) => {
                dialog.id && dispatch(dialogClose(dialog.id));
            }
        }
    ],
    easyClose: true,
}));
